import { useSelector, useDispatch } from 'react-redux'

import * as notificationSelector from 'selectors/notification'

import {
  clearNotification,
  notificationButtonClick,
} from 'reducers/notification'

import NotificationBar from './NotificationBar'

const Notification = () => {
  const notificationId = useSelector(notificationSelector.notificationId)
  const text = useSelector(notificationSelector.text)
  const type = useSelector(notificationSelector.type)
  const hideRefreshLink = useSelector(notificationSelector.hideRefreshLink)
  const actionButtons = useSelector(notificationSelector.actionButtons)

  const dispatch = useDispatch()

  const actionButtonClick = ({ notificationId, buttonId }) => {
    dispatch(notificationButtonClick({
      notificationId: notificationId,
      buttonId: buttonId,
    }))
  }

  const clearNotification_ = () => {
    dispatch(clearNotification({ notificationId: notificationId }))
  }

  return (
    <NotificationBar
      notificationId={notificationId}
      text={text}
      type={type}
      hideRefreshLink={hideRefreshLink}
      actionButtons={actionButtons}
      actionButtonClick={actionButtonClick}
      clearNotification={clearNotification_}
      dataTest='notification'
    />
  )
}

export default Notification
